module.exports = __webpack_public_path__ + "img/fire-alarm.d9e5f649.jpg";